module.exports = __webpack_public_path__ + "static/img/1.913e2f3d.gif";